import React from 'react';

interface MoreIconProps {
  size?: number;
  /** Rotate the kebab to a horizontal ellipsis (···). */
  horizontal?: boolean;
}

const MoreIcon: React.FC<MoreIconProps> = ({ size = 22, horizontal = false }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={horizontal ? { transform: 'rotate(90deg)' } : undefined}
    >
      <circle cx="12" cy="5" r="2" />
      <circle cx="12" cy="12" r="2" />
      <circle cx="12" cy="19" r="2" />
    </svg>
  );
};

export default MoreIcon;
